import React, { Component } from 'react';
import PropTypes from 'prop-types';
import CompanyList from './company_list';
import CompanyDetail from './company_detail';

class Company extends Component {
  componentDidMount(){
  }
  render() {
    //console.log(this.context);
    var params = this.context.router.route.match.params;
    var view;
    if(params.action===undefined){
      view = <CompanyList/>;
    }else{
      if(params.id===undefined){
        view = <CompanyDetail/>;
      }else{
        view = <CompanyDetail action={params.action}/>;
      }
    }
    return (
      <div className="page-wrapper">{view}</div>
    );
  }
}

Company.contextTypes = {
  router: PropTypes.object
};

export default Company;
